import React, { useEffect, useState } from "react";
import { GetAllJobs } from "Services/OtherApis";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
function AllJoBs() {
  const { t, i18n } = useTranslation();
  const isRTL = i18n.dir() === "rtl";
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [language, setSelectedLanguage] = useState(isRTL ? "ar" : "en");
  useEffect(() => {
    getAllJobsData();
  }, []);

  async function getAllJobsData() {
    setLoading(true);
    try {
      const res = await GetAllJobs();
      setData(res?.data || []); // Ensure data is always an array
    } catch (e) {
      console.error("Error fetching jobs:", e);
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="w-full">
      <div className="font-semibold text-xl  tracking-wide">
        {t("All Jobs")}
      </div>

      {loading ? (
        <p className="text-gray-600 mt-4 text-center border border-gray-300  py-24 text-lg rounded-md">
          {t("Loading Jobs")} ...
        </p>
      ) : data?.length === 0 ? (
        <p className="text-gray-600 mt-4 text-center border border-gray-300  py-24 text-lg rounded-md">
          {t("No Jobs Available")} !
        </p>
      ) : (
        <div className="mt-4 border border-gray-300 rounded-md">
          {data
            ?.filter((v) => v?.jobTitle?.[language])
            ?.map((job, index) => (
              <div
                onClick={() => navigate(`/career/job/${job._id}`)}
                key={index}
                className="flex items-center justify-between py-4 border-b cursor-pointer border-gray-300 hover:bg-gray-300  px-3 duration-300 "
              >
                <div className="flex items-center space-x-2 rtl:space-x-reverse">
                  <div className="text-purple-500 text-3xl mr-4">
                    {/* Example icon - replace with your icon */}
                    {job?.image ? (
                      <img
                        src={job?.image}
                        alt="Job Icon"
                        className="h-14 w-14"
                      />
                    ) : (
                      <div className="h-14 w-14 bg-gray-200 rounded-full flex items-center justify-center">
                        <span className="text-gray-500 text-sm">No Image</span>
                      </div>
                    )}
                  </div>
                  <div>
                    <h3 className="text-lg font-bold text-black hover:underline cursor-pointer duration-300">
                      {job.jobTitle?.[language]}
                    </h3>
                    <p className="text-sm text-gray-600">
                      {t("Experience")}: {job.experience?.[language]}
                    </p>
                  </div>
                </div>
                <div className="flex items-center space-x-10 rtl:space-x-reverse">
                  <div className="text-right">
                    <p className="text-sm text-gray-600">
                      {job.location?.[language]}
                    </p>
                    <p className="text-md text-blue-500 font-medium">
                      {job.jobType?.[language] || "N/A"}
                    </p>
                  </div>
                  {/* <div
                  onClick={() =>
                    navigate(`/applicants/allapplicants?job=${job._id}`)
                  }
                  className="w-max bg-green-500 text-white py-2 px-2.5  text-sm rounded-lg shadow-xl cursor-pointer duration-300 hover:bg-green-600"
                >
                  {t("View Applicants")}
                </div> */}
                  {/* Edit and Delete Icons */}
                  {/* <div className="flex items-center space-x-2 rtl:space-x-reverse">
                <MdEdit
                  className="text-blue-500 text-2xl cursor-pointer hover:text-blue-700"
                  onClick={() => handleEdit(index)}
                />
                <MdDelete
                  className="text-red-500 text-2xl cursor-pointer hover:text-red-700"
                  onClick={() => handleDelete(index)}
                />
              </div> */}
                </div>
              </div>
            ))}
        </div>
      )}
    </div>
  );
}

export default AllJoBs;
